<script setup lang="ts">
interface IProps {
    hasBackground?: boolean;
    noPadding?: boolean;
    customMinHeight?: string | number;
}
defineProps<IProps>();
const minHeight = ref(550);
const setMinHeight = () => {
    if (typeof window !== 'undefined') {
        minHeight.value = window.innerHeight - 70;
    }
};
onMounted(() => {
    setMinHeight();
    if (typeof window !== 'undefined') {
        window.onresize = () => setMinHeight();
    }
});
</script>

<template>
    <div>
        <div class="container-wrapper">
            <div
                class="container main-container"
                v-bind="$attrs"
                :class="{
                    'has-background': hasBackground,
                    'no-padding': noPadding,
                }"
                :style="{ 'min-height': customMinHeight || `${minHeight}px` }"
            >
                <slot />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.container {
    width: $app-container-max-width;
    max-width: 100vw;
    margin: 0 auto;
}

.has-background {
    background: white;
}

.no-padding {
    padding: 0;
}
.container-wrapper {
    padding: 1px 0;
}

@media (max-width: $app-container-max-width) {
    .container {
        padding-left: 16px;
    }
}

@media (max-width: $app-tablet-max-width) {
    .container {
        width: 100%;
        padding: 8px;
    }

    .container-wrapper {
        padding: 0 8px;
    }
}
</style>
